@if (showLabel) {
  <div class="fx--h fx--label fx--label__nowrap fx--label__bold fx--juc-space-between">
    <label class="miq-form-input-label" [attr.for]="filter$().key">{{ filter$().value }}</label>
    @if (showOptionMenuIcon()) {
      <div
        cbre-filter-option
        [filter]="filter$()"
        [form]="form"
        (filterOptionChange)="filterOptionChange.emit($event)"
      ></div>
    }
  </div>
}

@switch (filter$().inputType) {
  @case ('date') {
    <mat-form-field appearance="outline">
      <input
        matInput
        [formControl]="control"
        [attr.aria-label]="filter$().value"
        [placeholder]="filter$().placeholder"
        [disabled]="control.disabled"
        [matDatepicker]="equalDatePicker"
        autocomplete="no-autofill"
      />
      @if (_clearVisible()) {
        <em
          class="multiselect-clear pi pi-times-circle"
          matSuffix
          (click)="control.setValue(null); handleChange()"
        ></em>
      }
      <mat-datepicker-toggle matSuffix [for]="equalDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #equalDatePicker></mat-datepicker>
    </mat-form-field>
  }

  @case ('dropdown') {
    <p-select
      class="primeng-dropdown equal-item-dp"
      [formControl]="control"
      [attr.aria-label]="filter$().value"
      [placeholder]="filter$().placeholder"
      [options]="options"
      [disabled]="filter$().disabled"
      [appendTo]="'body'"
      [showClear]="hasClearIcon"
      (onChange)="handleChange()"
    >
      <!-- Custom item template: show disabled labels grayed out while keeping the option selectable for un-selecting -->
      <ng-template let-option pTemplate="item">
        <span [class.disabled-option-label]="option.disabledLabel">{{ option.label }}</span>
      </ng-template>
      <!-- Clear icon-->
      <ng-template pTemplate="clearicon">
        <em class="multiselect-clear pi pi-times-circle" (click)="control.setValue(null)"></em>
      </ng-template>
    </p-select>
  }

  @default {
    <mat-form-field appearance="outline">
      <input
        matInput
        [id]="filter$().key"
        [formControl]="control"
        [type]="filter$().inputType"
        [readonly]="control?.disabled"
        [attr.aria-label]="filter$().value"
        [placeholder]="filter$().placeholder"
        autocomplete="no-autofill"
        (keydown.enter)="handleChange()"
      />
      @if (_clearVisible()) {
        <em
          class="multiselect-clear pi pi-times-circle"
          matSuffix
          (click)="control.setValue(null); handleChange()"
        ></em>
      }
    </mat-form-field>
  }
}
